import React, { Fragment, Component } from 'react'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/dist/style.css'

import { Error, Label, SubLabel } from '../InputLabels/InputLabels'

// styles
import {
  DatePickerInputField,
  DateTimeRow,
  DateTimeRowItem,
  DateTimeRowLabel,
  Wrapper
} from './styles'

class DateTimeRangePicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isPickerOpen: false,
      selectedDay: props.field.value ? new Date(props.field.value) : null
    }
  }

  formatDate = date => {
    if (!date) return null

    const day = `${date.getDate()}`.padStart(2, '0')
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const year = date.getFullYear()
    return `${year}-${month}-${day}`
  }

  handleDayClick = day => {
    const { disabled, onChange } = this.props
    if (disabled) return null

    this.setState({ selectedDay: day, isPickerOpen: false })

    if (onChange) {
      onChange({ start_date: this.formatDate(day) })
    }
  }

  togglePicker = () => {
    const { disabled } = this.props
    if (disabled) return null

    this.setState(prevState => ({ isPickerOpen: !prevState.isPickerOpen }))
  }

  componentDidUpdate(prevProps) {
    // Update selectedDay if field value changes
    if (prevProps.field.value !== this.props.field.value) {
      this.setState({
        selectedDay: this.props.field.value ? new Date(this.props.field.value) : null
      })
    }
  }

  render() {
    const {
      actionLabel = 'Select a date',
      disabled,
      field,
      form: { errors },
      label,
      subLabel
    } = this.props
    const { isPickerOpen, selectedDay } = this.state
    const error = errors[field.name]

    return (
      <Fragment>
        {label && <Label htmlFor={field.name}>{label}</Label>}
        {subLabel && <SubLabel subLabel={subLabel}>{subLabel}</SubLabel>}

        <Wrapper disabled={disabled} hasError={!!error}>
          <DateTimeRow borderBottom>
            {!isPickerOpen && (
              <DateTimeRowLabel onClick={this.togglePicker}>{actionLabel}</DateTimeRowLabel>
            )}

            <DateTimeRowItem>
              {!isPickerOpen && (
                <DatePickerInputField
                  disabled={disabled}
                  onFocus={this.togglePicker}
                  value={this.formatDate(selectedDay)}
                  readOnly // Optional: makes the input field read-only
                />
              )}

              {isPickerOpen && (
                <DayPicker
                  mode="single"
                  selected={selectedDay}
                  onSelect={this.handleDayClick}
                  footer={
                    this.state.isPickerOpen ? (
                      <button onClick={() => this.setState({ isPickerOpen: false })}>Close</button>
                    ) : (
                      undefined
                    )
                  }
                />
              )}
            </DateTimeRowItem>
          </DateTimeRow>
        </Wrapper>

        {error && <Error>{error}</Error>}
      </Fragment>
    )
  }
}

export default DateTimeRangePicker
